import React, { DetailedHTMLProps, FC, ReactNode } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { z, ZodObject, ZodRawShape } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

type Props<S extends ZodRawShape, T extends ZodObject<S>> = {
  defaultValues?: any;
  onSubmit: (values: z.infer<T>) => void;
  schema: T;
} & Omit<
  DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>,
  "onSubmit"
>;

export const Form = <S extends ZodRawShape, T extends ZodObject<S>>({
  onSubmit,
  children,
  defaultValues,
  schema,
  ...rest
}: Props<S, T>) => {
  const methods = useForm({
    defaultValues,
    resolver: zodResolver(schema),
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} {...rest}>
        {children}
      </form>
    </FormProvider>
  );
};
